import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class InventoryService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    deleteAssociations(data: Models.IDeleteInventoryAssociationsModel) {
        return this.toRLService<boolean>("/api/inventory/deleteassociations").post(data).$promise;
    }

    createAssociations(data: Models.ICreateInventoryAssociationsModel) {
        return this.toRLService<boolean>("/api/inventory/createassociations").post(data).$promise;
    }
}